// Story 8.10 (ADO-2019), DV-34: where the HHT pages live. `/hht-orders` lists what is
// waiting (or redirects to the one order); `/hht-orders/{id}` reviews one order.

export const HHT_ORDERS_ROUTE = '/hht-orders';

/** The review of one waiting order. */
export function hhtOrderPath(hhtOrderId: string): string {
  return `${HHT_ORDERS_ROUTE}/${encodeURIComponent(hhtOrderId)}`;
}
